import { render, staticRenderFns } from "./tanimlama.vue?vue&type=template&id=213ba039&scoped=true&"
import script from "./tanimlama.vue?vue&type=script&lang=js&"
export * from "./tanimlama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213ba039",
  null
  
)

export default component.exports